// The pending list's "unread first" grouping is frozen for the duration of a
// browsing session by an anchor timestamp (see OpportunitiesTab). The backend
// groups a row as unread when `viewed_at IS NULL OR viewed_at >= unread_anchor`,
// so a row read during the session keeps its position instead of sliding into
// the read group and shifting every later page under OFFSET/LIMIT paging.
//
// The API's datetimes are naive UTC (matching the `viewed_at` column), so the
// trailing `Z` that `toISOString()` emits has to go — an offset-aware value
// would not compare against a naive column server-side.
export const toUnreadAnchor = (date: Date): string => date.toISOString().replace(/Z$/, '');

export const nowUnreadAnchor = (): string => toUnreadAnchor(new Date());
